import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitch from './LanguageSwitch';
import ThemeSwitch from './ThemeSwitch';
import Icon from './common/Icon';
import { ICONS } from '../utils/fontAwesome';

const Navigation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <nav className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="mx-auto px-2 sm:px-4 w-full sm:w-[85%] md:w-[85%] lg:w-[85%] xl:w-[85%] 2xl:w-[85%]">
        <div className="flex justify-between items-center py-4">
          {/* Logo/Title */}
          <div className="flex items-center">
            <div>
              <h1 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center space-x-2">
                <Icon icon={ICONS.LOCK} />
                <span>{t('privacy.title')}</span>
              </h1>
              <p className="text-xs text-gray-500 dark:text-gray-400 hidden sm:block">
                {t('privacy.description')}
              </p>
            </div>
          </div>

          {/* Right side - Navigation Links, Theme Switch and Language Switch */}
          <div className="flex items-center space-x-6">
            {/* Navigation Links */}
            <div className="hidden md:flex items-center space-x-6">
              <Link
                to="/"
                className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/about.html"
                className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                {t('nav.about')}
              </Link>
              <Link
                to="/faq.html"
                className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                {t('nav.faq')}
              </Link>
              <Link
                to="/contact.html"
                className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
              >
                {t('nav.contact')}
              </Link>
            </div>

            {/* Theme and Language Switches */}
            <div className="flex items-center space-x-4">
              <ThemeSwitch />
              <LanguageSwitch />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;